<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="heading">
        Website Clicks &amp; Impressions
      </h3>
      <a
        v-if="!editing && !preview"
        class="btn primary_btn btn_sm"
        href="/reporting"
      >
        See More
      </a>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove()"
        >
          Delete
        </button>
      </div>
    </div>
    <apexchart
      v-if="!loading && !error"
      :options="chartOptions"
      :series="series"
      height="300"
      type="area"
    />

    <div
      v-if="loading && !error"
      class="loading_widget_data"
    >
      <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
    </div>

    <div
      v-if="error"
      class="widget_error"
      v-html="error"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';

export default {
  props: {
    widget: {
      type: Object,
      default: null,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      error: '',
      series: [
        {
          name: "Clicks",
          data: []
        },
        {
          name: "Impressions",
          data: []
        }],
      options: {
        colors: ['#0062a3', '#6500a3', '#33adff', '#be54ff'],
        xaxis: {
          categories: [],
          type: 'datetime',

        },
        yaxis: [
          {
            opposite: true,
            seriesName: 'Clicks',
            title: {
              text: 'Clicks',
            },
            min: 0,
            max: 0,
            forceNiceScale: true
          },
          {
            seriesName: 'Impressions',
            title: {
              text: 'Impressions',
            },
            min: 0,
            max: 0,
            forceNiceScale: true
          },
        ],
        tooltip: {
          x: {
            format: 'd MMM yyyy',
          }
        }
      }
    }
  },
  computed: {
    ...mapState('dashboard', ['activeWebsite', 'chartBaseOptions', 'uuid', 'preview']),
    ...mapState('user', ['user']),
    chartOptions() {
      return {
        ...this.chartBaseOptions,
        ...this.options
      };
    }
  },
  mounted() {
    if (this.activeWebsite.has_gsc_connection) {
      axios.post('/ajax/dashboard/get-widget-data', {
        type: 'searchConsole',
        uuid: this.uuid
      }).then(response => {
        this.options.yaxis[0].max = Math.max(...response.data.clicks.data);
        this.options.yaxis[1].max = Math.max(...response.data.impressions.data);

        this.series[0].data = response.data.clicks.data;
        this.series[1].data = response.data.impressions.data;
        this.options.xaxis.categories = response.data.clicks.labels;
        this.loading = false;
      }).catch(error => {
        this.error = error.response.data;
        this.loading = false;
      });
    } else {
      this.error = `<i class="fa fa-btn fa-exclamation-triangle"></i> <span>Please connect to Google Search Console.</span><a href="/website/settings/${this.user.active_website.hash_id}">Go to settings</a>`;
      this.loading = false;
    }
  },
}
</script>
